var Reverb = window.Reverb || {};
Reverb.Autosubmit = (function () {
  // Automatically submit parent forms of select
  // elements tagged as data-autosubmit
  function handleAutosubmitSelects() {
    $('[data-autosubmit]').change(function () {
      $(this).closest('form').submit();
    });
  }

  // Automatically submit parent forms of check boxes and selects
  // elements tagged as data-autosubmit-form
  function handleAutosubmitForms() {
    $(document).on('change', 'form[data-autosubmit-form] input[type=checkbox]:not(.omit-autosubmit), form[data-autosubmit-form] select:not(.omit-autosubmit), form[data-autosubmit-form] input[type=radio]:not(.omit-autosubmit)', function () {
      $(this).parents('form').submit();
    });
  }

  return {
    init: function () {
      handleAutosubmitSelects();
      handleAutosubmitForms();
    }
  };
})();

$(function () {
  Reverb.Autosubmit.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/autosubmit.js